import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SvgComponent = (props) => (
  <Svg
    {...props}
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11C0 4.928 4.928 0 11 0s11 4.928 11 11-4.928 11-11 11S0 17.072 0 11Zm2.2 0c0 4.862 3.938 8.8 8.8 8.8s8.8-3.938 8.8-8.8-3.938-8.8-8.8-8.8A8.798 8.798 0 0 0 2.2 11ZM16 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
      fill="#E40046"
    />
  </Svg>
);

export default SvgComponent;
